import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m5.202-3.05A9.46 9.46 0 0 1 12 21.5c-1.92 0-3.708-.57-5.202-1.55.285-.916.563-1.456.849-1.77.267-.293.576-.43 1.093-.43h6.52c.516 0 .826.137 1.093.43.286.314.564.854.849 1.77m1.253-.98c-.268-.743-.583-1.35-.993-1.8-.599-.657-1.34-.92-2.203-.92H8.74c-.863 0-1.603.263-2.201.92-.41.451-.725 1.057-.993 1.8a9.5 9.5 0 1 1 12.91 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }